/** @format */

// https://www.tutorialrepublic.com/javascript-tutorial/javascript-cookies.php
const getCookie = function (name: string) {
  // Split cookie string and get all individual name=value pairs in an array
  var cookieArr = document.cookie.split(';');

  // Loop through the array elements
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split('=');

    /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
    if (name == cookiePair[0].trim()) {
      // Decode the cookie value and return
      return decodeURIComponent(cookiePair[1]);
    }
  }

  // Return null if not found
  return null;
};

// https://www.tutorialrepublic.com/javascript-tutorial/javascript-cookies.php
const setCookie = function (
  name: string,
  value: string,
  daysToLive: number = 1
) {
  var cookie = name + '=' + encodeURIComponent(value);

  if (typeof daysToLive === 'number') {
    /* Sets the max-age attribute so that the cookie expires
      after the specified number of days */
    cookie += '; max-age=' + daysToLive * 24 * 60 * 60;
  }

  document.cookie = cookie;
};

const deleteAllCookies = new Promise((resolve, reject) => {
  try {
    var cookies = document.cookie.split(';');

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf('=');
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
      eraseCookieFromAllPaths(name);
    }
    window.localStorage.clear();
    setTimeout(function () {
      resolve('');
    }, 2500);
  } catch (error) {
    reject(error);
  }
});

function eraseCookieFromAllPaths(name: string) {
  // This function will attempt to remove a cookie from all paths.
  var pathBits = window.location.pathname.split('/');
  var pathCurrent = ' path=';

  // do a simple pathless delete first.
  document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;';

  for (var i = 0; i < pathBits.length; i++) {
    pathCurrent += (pathCurrent.substr(-1) != '/' ? '/' : '') + pathBits[i];
    document.cookie =
      name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;' + pathCurrent + ';';
  }
}

export { setCookie, getCookie, deleteAllCookies };
